module.exports = __webpack_public_path__ + "img/tree2.e353d3a.svg";